import { Hub } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';

import { ProjectScoreCard } from '@/ui/pages/app/components/project-page/components/ProjectScoreCard';

export function DevProjectCard() {
  return (
    <>
      <Box sx={{ width: 500 }}>
        <Stack
          sx={{
            gap: 3,
          }}
        >
          selected = true
          <ProjectScoreCard
            scoreIcon={<Hub />}
            scoreTextColor="red"
            scoreBackgroundColor="blue"
            scoreTitle="Score title"
            resultValue={10000}
            resultUnit="km"
            resultSecondLine="1092 km / jour"
            infos="infos yeah"
            selected={true}
            onClick={() => {}}
            scoreLetter="Y"
          />
          selected = false
          <ProjectScoreCard
            scoreIcon={<Hub />}
            scoreTextColor="red"
            scoreBackgroundColor="blue"
            scoreTitle="Score title"
            resultValue={10000}
            resultUnit="km"
            resultSecondLine="1092 km / jour"
            infos="infos yeah"
            selected={false}
            onClick={() => {}}
            scoreLetter="Y"
          />
        </Stack>
      </Box>
    </>
  );
}
